import React from "react";
import { withRouter } from "../components/withRouter";
import Header from "../components/header";
import { AiOutlineArrowLeft, AiOutlinePlus, AiOutlineQrcode, AiOutlineDelete, AiOutlineClose } from "react-icons/ai";
import { Link } from "react-router-dom";
import { LogoSvg } from "../components/loading";
import { hostsSettings } from "../configs/app.config";
import ConfirmaitonModal from "../components/confirmation_modal";

class Templates extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      templates: [],
      submenuModal: false,
      selectedTemplate: null,
      confirmation: false,
    };
  }

  getTemplates() {
    this.setState({ isLoading: true });
    fetch(hostsSettings.apiPage + "/templates", {
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("digitalkassir_idtn_cms_frm"),
      }),
      method: "GET",
      cache: "no-cache",
      mode: "cors",
      credentials: "include",
    })
      .then((res) => res.json())
      .then((res) => {
        if (!res.error) {
          this.setState({ templates: res?.data, isLoading: false });
        }
      });
  }

  openMenu(id) {
    this.setState({ submenuModal: true, selectedTemplate: id });
  }

  deleteTemplate() {
    this.setState({ isLoading: true, submenuModal: false });
    fetch(hostsSettings.apiPage + "/templates", {
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + localStorage.getItem("digitalkassir_idtn_cms_frm"),
      }),
      method: "DELETE",
      cache: "no-cache",
      mode: "cors",
      credentials: "include",
      body: JSON.stringify({
        selectedTemplate: this.state.selectedTemplate,
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        if (!res.error) {
          this.getTemplates();
          this.setState({ isLoading: false });
        } else {
          this.setState({ isLoading: false, confirmation: true });
        }
      });
  }
  handleCloseConfirmationAction = () => {
    this.setState({ confirmation: false });
  };
  render() {
    return (
      <div>
        <Header
          back={
            <Link to="/main">
              <AiOutlineArrowLeft />
            </Link>
          }
          pageName={"Шаблоны"}
        />
        {this.state.isLoading ? (
          <div className="loading_logo">
            <LogoSvg />
          </div>
        ) : (
          ""
        )}
        {/* <button className={'btn btn_tdk_auto_width'}>
          <AiOutlinePlus style={{height: 20, width: 20, color: 'white', marginRight: 5}}/>
          <span>Создать шаблон</span>
        </button> */}
        <Link to="/sales/new?template" className={"btn btn_tdk_transparent"}>
          <div className={"icon"}>
            <AiOutlinePlus style={{ height: 20, width: 20 }} />
          </div>
          <div className={"btn_content"}>
            <span>Добавить шаблон</span>
          </div>
        </Link>
        <br />
        {this.state.templates.length === 0 ? (
          "Список шаблонов - пуст"
        ) : (
          <div>
            {this.state.templates.map((template, index) => {
              return (
                <button
                  onClick={() => {
                    this.openMenu(template.id);
                  }}
                  key={"temp_" + index}
                  className={"btn btn_tdk_transparent"}>
                  <div className={"icon"}>
                    <AiOutlineQrcode style={{ height: 20, width: 20 }} />
                  </div>
                  <div className={"btn_content"}>
                    <span>{template.name}</span>
                    <span className={"price"}>{template.price} ₽</span>
                  </div>
                </button>
              );
            })}
          </div>
        )}
        {this.state.submenuModal === true ? (
          <div className="submenuModal">
            <div class="submenuModal_bg"></div>
            <div
              className="submenuModal_close"
              onClick={() => {
                this.setState({ submenuModal: false });
              }}>
              <AiOutlineClose />
            </div>
            <div className="submenuModal_body">
              {/* <div><AiOutlineEdit /> Редактировать</div> */}
              <div
                onClick={() => {
                  this.deleteTemplate();
                }}>
                <AiOutlineDelete /> Удалить
              </div>
            </div>
          </div>
        ) : (
          ""
        )}

        {this.state.confirmation === true ? (
          <ConfirmaitonModal
            closeAction={this.handleCloseConfirmationAction}
            image="🥺"
            title="Ошибка"
            description="Не удалось удалить шаблон, обратитесь тех. поддержку"
            cancelText="Понятно"
          />
        ) : (
          ""
        )}
      </div>
    );
  }

  componentDidMount() {
    this.getTemplates();
  }
}

export default withRouter(Templates);
